import { useTranslation } from "react-i18next";

import { Icon } from "#shared/icons/Icon";
import { Group } from "#shared/view/components/Group";
import { Modal } from "#shared/view/components/Modal";
import { Button } from "#shared/view/designSystem/Button";

type DeleteMaterialsConfirmationModalProps = {
  opened: boolean;
  onClose: () => void;
  onDelete: () => void;
};
export const DeleteMaterialsConfirmationModal = ({
  opened,
  onClose,
  onDelete,
}: DeleteMaterialsConfirmationModalProps) => {
  const { t } = useTranslation();

  const deleteMaterials = () => {
    onDelete();
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("settings.materials.confirmaDeleteTitle")}
      size="lg"
    >
      <p>{t("settings.materials.confirmDeleteMessage")}</p>
      <Group gap="xs" justify="end">
        <Button variant="outline" onClick={onClose}>
          {t("common.cancel")}
        </Button>
        <Button
          variant="light"
          color="red"
          onClick={deleteMaterials}
          leftSection={<Icon name="trash" />}
        >
          {t("common.delete")}
        </Button>
      </Group>
    </Modal>
  );
};
